import moment from "moment";
import _Vue from "vue";

export function UtilsPlugin(Vue: typeof _Vue): void {
  Vue.prototype.$eventHub = new Vue();

  Vue.prototype.$formatDate = (val: Date | string, format: string) => {
    if (val) {
      return moment(val).format(format);
    }
    return "";
  };
}

declare module "vue/types/vue" {
  interface Vue {
    $formatDate(val: Date | string, format: string): string;
  }
}
